import icCloseSquare from 'assets/images/ic-close-square.svg'
import Button from 'components/commons/button'
import { Import } from 'components/commons/import/Import'
import Modal from 'components/commons/modal'
import { TABLE_INTERNAL_MOVEMENT_IMPORT } from 'configs/hr-metrics/configTableInternalMovementList'
import { useEffect, useState } from 'react'
import { API_INTERNAL_MOVEMENT } from 'services/apiInternalMovement'

export const ImportInternalMovementContainer = ({ show, onHide }) => {
    const [isComplete, setIsComplete] = useState(false)

    useEffect(() => {
        if (show) setIsComplete(false)
    }, [show])

    const api = {
        fetchTemplate: API_INTERNAL_MOVEMENT.DOWNLOAD_TEMPLATE,
        fetchValidate: API_INTERNAL_MOVEMENT.FILE_VALIDATION,
        fetchImport: API_INTERNAL_MOVEMENT.IMPORT,
    }

    const props = {
        title: 'Internal Movement',
        columnTableView: TABLE_INTERNAL_MOVEMENT_IMPORT,
        api: api,
        returnTitle: 'View Internal Movement',
        onHide: onHide,
        setCompleteImport: (value) => setIsComplete(value),
    }

    return (
        <Modal dialogClassName='w-[70%]' contentClassName='rounded-xl' show={show}>
            <div className={'px-6 py-3 flex flex-row items-center justify-between border-b'}>
                <p className={'font-semibold text-md'}>Import Data</p>
                <Button
                    type='outline'
                    shape='circle'
                    size='small'
                    icon={icCloseSquare}
                    onClick={() => onHide(isComplete)}
                />
            </div>
            <div className='overflow-auto'>
                <Import {...props} />
            </div>
        </Modal>
    )
}
